(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'shortid', 'react', '@material-ui/core/styles', '@material-ui/core/MenuItem', '@material-ui/core/Select', '@material-ui/core/Input', '@material-ui/core/InputLabel', '@material-ui/core/FormHelperText', '@material-ui/core/FormControl', '../../elements/typography', '../../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('shortid'), require('react'), require('@material-ui/core/styles'), require('@material-ui/core/MenuItem'), require('@material-ui/core/Select'), require('@material-ui/core/Input'), require('@material-ui/core/InputLabel'), require('@material-ui/core/FormHelperText'), require('@material-ui/core/FormControl'), require('../../elements/typography'), require('../../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.shortid, global.react, global.styles, global.MenuItem, global.Select, global.Input, global.InputLabel, global.FormHelperText, global.FormControl, global.typography, global.colors);
    global.Dropdown = mod.exports;
  }
})(this, function (exports, _shortid, _react, _styles, _MenuItem, _Select, _Input, _InputLabel, _FormHelperText, _FormControl, _typography, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var shortid = _interopRequireWildcard(_shortid);

  var React = _interopRequireWildcard(_react);

  var _MenuItem2 = _interopRequireDefault(_MenuItem);

  var _Select2 = _interopRequireDefault(_Select);

  var _Input2 = _interopRequireDefault(_Input);

  var _InputLabel2 = _interopRequireDefault(_InputLabel);

  var _FormHelperText2 = _interopRequireDefault(_FormHelperText);

  var _FormControl2 = _interopRequireDefault(_FormControl);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var Dropdown = function Dropdown(_ref) {
    var testId = _ref['data-testid'],
        classes = _ref.classes,
        options = _ref.options,
        onChange = _ref.onChange,
        value = _ref.value,
        error = _ref.error,
        errorText = _ref.errorText,
        disabled = _ref.disabled,
        label = _ref.label,
        autoWidth = _ref.autoWidth,
        smallInput = _ref.smallInput,
        width = _ref.width;
    return React.createElement(
      _FormControl2.default,
      {
        disabled: disabled,
        style: { width: width },
        classes: !autoWidth && {
          root: smallInput ? classes.halfInputWidth : classes.defaultInputWidth
        }
      },
      React.createElement(
        _InputLabel2.default,
        null,
        React.createElement(
          _typography.Label,
          { style: { color: _colors2.default.slate } },
          label
        )
      ),
      React.createElement(
        _Select2.default,
        {
          'data-testid': testId,
          autoWidth: autoWidth,
          label: 'Select',
          className: classes.textField,
          value: value,
          onChange: onChange,
          errorText: errorText,
          margin: 'dense',
          error: error,
          input: React.createElement(_Input2.default, {
            classes: {
              underline: classes.cssUnderline,
              error: classes.error
            }
          })
        },
        options.map(function (option) {
          return React.createElement(
            _MenuItem2.default,
            { key: shortid.generate(), value: option.value },
            React.createElement(
              _typography.Label,
              null,
              option.label
            )
          );
        })
      ),
      error && errorText && React.createElement(
        _FormHelperText2.default,
        null,
        React.createElement(
          _typography.Note,
          { style: { color: _colors2.default.dragon } },
          errorText
        )
      )
    );
  };


  Dropdown.defaultProps = {
    error: false,
    errorText: '',
    disabled: false,
    autoWidth: false
  };

  var styles = {
    defaultInputWidth: {
      width: '19.5rem'
    },
    halfInputWidth: {
      width: '12.5rem'
    },
    inputValueText: {
      fontFamily: 'Proxima Nova, Arial, Helvetica, sans-serif'
    },
    cssLabel: {
      '&$cssFocused': {
        color: _colors2.default.prussian
      }
    },
    cssFocused: {},
    cssUnderline: {
      '&:after': {
        borderBottomColor: _colors2.default.prussian
      }
    },
    error: {
      '&$error:after': {
        borderBottomColor: _colors2.default.dragon
      }
    },
    labelStyleOverride: {
      fontSize: '2px important!'
    }
  };

  exports.default = (0, _styles.withStyles)(styles)(Dropdown);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Inputs/Dropdown.js
// module id = 1952
// module chunks = 1